import {
  deleteItemsFromSessionStorage,
  flattenObjectWithChar,
  getSessionStorageItems,
  hasValue,
  isFunction,
  isNullOrUndefined,
  safeParseJSON,
} from '@r-and-a-shared-ui/utils';
import { TEMP_PASSWORD } from '../constants';
import { FieldError, FieldValues, FormState } from 'react-hook-form';
import { FormFieldProps } from '../fields';
import { defaultValidationMessage } from '../fields/config/validators/validators';
import { ZodIssueCode } from 'zod';

export const getInitialStateFromSessionStorage = () => {
  const keys = [TEMP_PASSWORD];

  const initialState = getSessionStorageItems(keys);
  deleteItemsFromSessionStorage(keys);

  return initialState;
};

export const setFormStateFromSessionStorage = (
  setValue: (...args: any[]) => any,
) => {
  if (!isFunction(setValue)) {
    return;
  }

  const sessionStorageFormValues = getInitialStateFromSessionStorage();

  if (!hasValue(sessionStorageFormValues)) {
    return;
  }

  Object.keys(sessionStorageFormValues)?.forEach(key => {
    if (isNullOrUndefined(sessionStorageFormValues?.[TEMP_PASSWORD])) {
      return;
    }
    setValue(
      key,
      sessionStorageFormValues?.[key as keyof typeof sessionStorageFormValues],
    );
  });
};

export const getErrorMessageForCurrentField = (
  getFieldState: (
    name: string,
    formState?: FormState<FieldValues> | undefined,
  ) => {
    invalid: boolean;
    isDirty: boolean;
    isTouched: boolean;
    error?: FieldError | undefined;
  },
  fieldProps: FormFieldProps,
) => {
  const { name, dependencyValidationMessage, validationMessage } = fieldProps;
  const currentFieldState = getFieldState(name);

  const error =
    ((currentFieldState?.error as any)?.[name] as FieldError) ||
    currentFieldState?.error;

  if (error?.type === 'manual' && hasValue(error.message)) {
    return error.message;
  }

  return error?.type === ZodIssueCode.invalid_intersection_types &&
    hasValue(dependencyValidationMessage)
    ? dependencyValidationMessage
    : validationMessage || defaultValidationMessage;
};

export type GetDefaultValuesArgs = {
  callbackUrl?: string;
  predefinedJSONObj?: string;
  hardcodedDefaultValues?: unknown;
};

export const getDefaultValues = (args: GetDefaultValuesArgs) => {
  const { callbackUrl, hardcodedDefaultValues, predefinedJSONObj } = args;
  if (hasValue(callbackUrl)) {
    return hardcodedDefaultValues;
  } else if (hasValue(predefinedJSONObj) && predefinedJSONObj !== undefined) {
    return safeParseJSON(predefinedJSONObj);
  }
  return undefined;
};

export type GetInitialDefaultValuesArgs = {
  queryRes?: unknown;
  predefinedJSONObj?: string;
};
export const getDefaultValuesInitialFormState = (
  args: GetInitialDefaultValuesArgs,
) => {
  const { queryRes, predefinedJSONObj } = args;

  if (hasValue(queryRes)) {
    return flattenObjectWithChar(queryRes, '_');
  } else if (hasValue(predefinedJSONObj) && predefinedJSONObj !== undefined) {
    return flattenObjectWithChar(safeParseJSON(predefinedJSONObj), '_');
  }
  return {};
};
